// extracted by mini-css-extract-plugin
module.exports = {"promotion":"StorePromotion_promotion___AYak"};